import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Calendar — preferred pickup date picker. */
export function CalendarIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <rect x="3.5" y="5" width="17" height="15.5" rx="1.5" />
      <path d="M3.5 9.5h17" />
      <path d="M8 3v4M16 3v4" />
      <path d="M8 14h.01M12 14h.01M16 14h.01M8 17h.01M12 17h.01" />
    </PortalIcon>
  );
}
